export const get = async ({ url, params = {}, headers = {} }: { url: string; params?: Record<string, string>; headers?: Record<string, string> }) => {
  const queryParams = new URLSearchParams(params).toString()
  const fullUrl = queryParams ? `${url}?${queryParams}` : url

  const response = await fetch(fullUrl, {
    method: "GET",
    credentials: "include",
    headers: {
      ...headers
    }
  })

  return response.json()
}

export const post = async ({ url, params = {} }: { url: string; params?: any }) => {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
    credentials: "include",
  })

  return response.json()
}

